
import {Component, Vue} from 'vue-property-decorator'
import MaterialSelect from "@/components/material-select/index.vue";
import {apiShopLists, apiVideoAdd, apiVideoDetail, apiVideoEdit} from '@/api/shop'
import {debounce} from '@/utils/util'

@Component({
  components: {
    MaterialSelect
  }
})
export default class VideoEdit extends Vue {
  identity: number | null = null;
  shopData: any[] = []
  form: any = {
    // title: '',
    image: '',
    url: '',
    content: '',
    type: 1 // type=1表示视频
  };

  rules = {
    sid: [{required: true, message: '请选择商城', trigger: ['blur', 'change']}],
    image: [{required: true, message: '请上传视频封面', trigger: ['blur', 'change']}],
    url: [{required: true, message: '请输入视频', trigger: ['blur', 'change']}],
    content: [{required: true, message: '请输入标题', trigger: ['blur', 'change']}],
  };

  onSubmit(formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      if (!this.identity) {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    })
  }

  async handleAdd(): Promise<void> {
    await apiVideoAdd({...this.form})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async handleEdit(): Promise<void> {
    await apiVideoEdit({...this.form, id: this.identity})
    setTimeout(() => this.$router.go(-1), 500)
  }

  async getDetailFunc(): Promise<void> {
    const res = await apiVideoDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  created() {
    const query: any = this.$route.query
    this.identity = +query.id
    if (+query.id) {
      this.getDetailFunc()
    }
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)

  }
}
